module.exports = {"player_position":"","enemy_position":""};